<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header dark class="secondary white--text"
        >Job Summary</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <div
          class="d-flex flex-column align-center my-2 grey--text text--darken-2"
        >
          <span class="title">{{
            appointmentToUse.service_category.name
          }}</span>
          <span class="caption">Order placed {{ date }}</span>
          <span class="caption">Contact {{ job.customer.email }}</span>
        </div>
        <v-divider class="my-2"></v-divider>
        <div>
          <div class="d-flex justify-space-between">
            <v-subheader>Notes</v-subheader>
          </div>
          <CommentsTable :job-id="job.id" />
        </div>
        <v-divider class="my-2"></v-divider>
        <div>
          <div class="d-flex justify-space-between">
            <v-subheader>Files</v-subheader>
            <v-tooltip left>
              <template #activator="{ on }">
                <label>
                  <v-btn
                    text
                    icon
                    color="secondary"
                    v-on="on"
                    @click="triggerUpload"
                  >
                    <v-icon>mdi-image-plus</v-icon>
                  </v-btn>
                  <input
                    ref="fileUpload"
                    class="file-input"
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    name="photos"
                    multiple
                    @change="handleUpload"
                  />
                </label>
              </template>
              <span>Add Photos</span>
            </v-tooltip>
          </div>
          <PhotoGallery
            :loading="uploading"
            :job-id="job.id"
            :photos="visiblePhotos"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script setup lang="ts">
import { Appointment } from "serviceshift-ui/shared/src/typings/appointment";
import { Job } from "serviceshift-ui/shared/src/typings/job";
import { computed, ref } from "vue";
import { useStore } from "@/lib/vuex-composition";

import PhotoGallery from "@/components/PhotoGallery.vue";
import { usePhotoUpload } from "@/modules/photos/usePhotoUpload";
import CommentsTable from "../views/CommentsTable.vue";

const store = useStore();

const photoUpload = usePhotoUpload();

const props = defineProps<{ appointment: Appointment; job: Job }>();

const uploading = ref(false);
const fileUpload = ref(null);

const appointmentToUse = computed(() => {
  if (props.appointment) return props.appointment;
  if (!props.job) {
    return null;
  }
  const { appointments } = props.job;
  return appointments.find((appt) => appt.id === this.$route.params.id);
});
const visiblePhotos = computed(() => {
  return props.job.photos.filter((photo) => photo.customer_visible);
});
const date = computed(() => {
  if (!appointmentToUse.value) return "--";
  if (!appointmentToUse.value.scheduled_time) return "--";
  return new Date(appointmentToUse.value.scheduled_time).toLocaleDateString(
    "en-us"
  );
});

async function handleUpload(e) {
  uploading.value = true;

  try {
    await photoUpload.upload(props.job, e.target.files);

    await store.dispatch("fetchJob", appointmentToUse.value.job_id);

    uploading.value = false;
  } catch (e) {
    alert(e.message);
    uploading.value = false;
  }
}

function triggerUpload() {
  fileUpload.value.click();
}
</script>

<style lang="scss" scoped>
.file-input {
  display: none;
}
</style>
